import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 12.5V4.165m0 8.333c-.584 0-1.674-1.662-2.084-2.083m2.083 2.083c.584 0 1.674-1.662 2.084-2.083M4.166 15.832h11.667"
    />
  </svg>
)
export default SvgComponent
